import React from "react";
import {
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
} from "recharts";
import NoDataFound from "../Helper/NoDataFound";

const PieGraph = (props) => {
  
  const statusColors = {
    "INITIATED": "#5C9EEB",
    "PROCESSING": "#FFCE22",
    "USER_PAID": "#197E23",
    "REJECTED": "#818181",
    "CANCELLED": "#FF8A00",
    "FAILED": "#FF6A6A",
    "TOKEN_RECEIVED": "#5A36A8"
  };

  const data = props.data.status.map((status, index) => ({
    name: status,
    value: props.data.model_data[index],
    fill: statusColors[status] || "#F7F7F7",
  }));
  
  return (
    <>
      <div className="pie-chart-sec">
        {props.count ? <div className="pie-chart-label-sec">
          <div className="label-sec-inner">
            <div className="label-sec-inner-right">
              {props.data.status.map((status, index) => (
                <div className="label-sec-inner-right-item" key={index}>
                  <div className="label-sec-inner-right-item-name">
                    {status}
                  </div>
                  <div
                    className="label-sec-inner-right-item-color"
                    style={{ backgroundColor: statusColors[status] }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </div> : null}
        <ResponsiveContainer width="100%" height={400}>
          {props.count ? <PieChart width={730} height={250}>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={150}
              fill="#8884d8"
            />
            <Tooltip />
          </PieChart> : <NoDataFound/>}
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default PieGraph;
